import { estabelecimento } from "../Estabelecimento/estabelecimento"

//Função que valida o tempo da sessão do usuário
export const validaSessaoQRCode = (time, estabelecimento) => {

    time = Number(time)
    let date = new Date(time)
    let today = new Date()

    const tempoSessao = estabelecimento.qrCode.horasSessaoQRCode * 60 * 60 * 1000

    //Se o intervalo de tempo for maior que o tempo limite estipulado horas
    if ((date.getTime() + tempoSessao) < today.getTime()) {
        estabelecimento.qrCode.ativo = false
    } else {
        estabelecimento.qrCode.ativo = true
    }
}

export const criaIdentificadorUsuarioQRCode = () => {
    const EXPIRACAO = 12 * 60 * 60 * 1000; // 12 horas em milissegundos
    const gerarNovoId = () => 'client_' + Math.random().toString(36).slice(2, 11);

    const obterOuCriarIdentificador = () => {
        let identificadores = JSON.parse(localStorage.getItem('identificadorQRCode') || '{}');
        
        
        if (
            //se não existir um identificador para o estabelecimento
            !identificadores[estabelecimento.urlEmpresa] || 
            //ou se o tempo de expiração for maior que o tempo limite
            new Date().getTime() - identificadores[estabelecimento.urlEmpresa].ultimoAcesso > EXPIRACAO) {
            
            //cria um novo identificador
            identificadores[estabelecimento.urlEmpresa] = {
                ultimoAcesso: new Date().getTime(),
                id: gerarNovoId()
            };
            localStorage.setItem('identificadorQRCode', JSON.stringify(identificadores));
        }

        return identificadores[estabelecimento.urlEmpresa].id;
    };

    return obterOuCriarIdentificador();
};